<template>
  <div class="agradecimentos-page" ref="pageContainer">
    <div class="particles-container">
      <div v-for="n in 50" :key="n" class="particle" :style="getParticleStyle(n)"></div>
    </div>
    
    <div class="grid-overlay"></div>
    <div class="gradient-orb gradient-orb-1"></div>
    <div class="gradient-orb gradient-orb-2"></div>
    <section class="hero-section">
      <div class="hero-content">
        <h1 class="hero-title" data-aos="fade-up" data-aos-delay="100">
          <span class="title-year" >2025</span>
          <span class="title-text">Um ano de</span>
          <span class="title-highlight-wrapper">
            <span class="title-highlight">conquistas extraordinárias</span>
            <svg class="title-underline" viewBox="0 0 300 12" preserveAspectRatio="none">
              <path d="M0,10 Q150,0 300,10" stroke="currentColor" stroke-width="3" fill="none"/>
            </svg>
          </span>
        </h1>
        <p class="hero-subtitle" data-aos="fade-up" data-aos-delay="200">
          Obrigado por fazer parte dessa jornada. Sua confiança nos impulsiona a ir além.
        </p>
        <div
          class="scroll-indicator"
          data-aos="fade-up"
          data-aos-delay="400"
          @click="scrollToVideo"
          style="cursor: pointer;"
          aria-label="Ir para o vídeo"
        >
          <div class="mouse">
            <div class="wheel"></div>
          </div>
          <span>Role para explorar</span>
        </div>
      </div>
    </section>

    <section class="video-section" ref="videoSection">
      <div class="section-container">
        <div class="video-wrapper" data-aos="zoom-in" data-aos-delay="100">
          <div class="video-frame">
            <div class="video-glow"></div>
            <div class="video-border"></div>
            <video 
              ref="videoPlayer"
              controls 
              controlsList="nodownload"
              poster=""
              @play="onVideoPlay"
              @pause="onVideoPause"
            >
              <source src="/assets/videos/agradecimento_2025.mp4" type="video/mp4">
            </video>
            <div class="video-reflection"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="cta-section">
      <div class="cta-background">
        <div class="cta-pattern"></div>
      </div>
      <div class="section-container">
        <div class="cta-content" data-aos="zoom-in">
          <div class="cta-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/>
            </svg>
          </div>
          <h2 class="cta-title">Que 2026 seja ainda mais extraordinário</h2>
          <p class="cta-subtitle">Continuaremos juntos construindo um futuro de sucesso e prosperidade.</p>
          <div class="cta-signature">
            <div class="signature-line"></div>
            <span>Equipe Creditall</span>
            <div class="signature-line"></div>
          </div>
        </div>
      </div>
    </section>

    <footer class="page-footer">
      <div class="footer-content">
        <span>© 2025 Creditall. Todos os direitos reservados.</span>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Agradecimentos',
  data() {
    return {
      isScrolled: false,
      animatedStats: [0, 0, 0, 0],
      stats: [
        { icon: '📈', value: 150, prefix: '+', suffix: '%', label: 'Crescimento', description: 'Expansão dos negócios' },
        { icon: '🤝', value: 500, prefix: '+', suffix: '', label: 'Parceiros', description: 'Novas parcerias firmadas' },
        { icon: '⭐', value: 98, prefix: '', suffix: '%', label: 'Satisfação', description: 'Índice de aprovação' },
        { icon: '🏆', value: 25, prefix: '+', suffix: '', label: 'Prêmios', description: 'Reconhecimentos do setor' }
      ],
      timeline: [
        { month: 'JAN', title: 'Início de uma nova era', description: 'Lançamento de novos produtos e serviços inovadores.' },
        { month: 'ABR', title: 'Expansão nacional', description: 'Abertura de novas unidades em todo o Brasil.' },
        { month: 'JUL', title: 'Marco histórico', description: 'Alcançamos a marca de milhares de clientes atendidos.' },
        { month: 'OUT', title: 'Reconhecimento', description: 'Premiação como empresa destaque no setor.' },
        { month: 'DEZ', title: 'Celebração', description: 'Encerramos o ano com resultados extraordinários.' }
      ]
    }
  },
  mounted() {
    this.initAnimations();
    this.initScrollListener();
    this.animateCounters();
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    getParticleStyle() {
      const size = Math.random() * 4 + 1;
      return {
        width: `${size}px`,
        height: `${size}px`,
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        animationDelay: `${Math.random() * 20}s`,
        animationDuration: `${Math.random() * 20 + 20}s`
      }
    },
    initAnimations() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('aos-animate');
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

      document.querySelectorAll('[data-aos]').forEach(el => {
        observer.observe(el);
      });
    },
    initScrollListener() {
      window.addEventListener('scroll', this.handleScroll);
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    },
    animateCounters() {
      const duration = 2000;
      const frameRate = 60;
      const totalFrames = duration / (1000 / frameRate);
      
      this.stats.forEach((stat, index) => {
        let frame = 0;
        const increment = stat.value / totalFrames;
        
        const counter = setInterval(() => {
          frame++;
          this.animatedStats[index] = Math.min(Math.round(increment * frame), stat.value);
          
          if (frame >= totalFrames) {
            clearInterval(counter);
            this.animatedStats[index] = stat.value;
          }
        }, 1000 / frameRate);
      });
    },
    onVideoPlay() {
      this.$refs.videoPlayer.parentElement.classList.add('playing');
    },
    onVideoPause() {
      this.$refs.videoPlayer.parentElement.classList.remove('playing');
    },
    scrollToVideo() {
      const section = this.$refs.videoSection;
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}
</script>

<style scoped>

.agradecimentos-page {
  --color-bg-primary: #000000;
  --color-bg-secondary: #111111;
  --color-bg-tertiary: #1a1a1a;
  --color-accent-gold: rgb(201, 169, 98);
  --color-accent-gold-light: #e8d5a3;
  --color-text-primary: #ffffff;
  --color-text-secondary: rgba(255, 255, 255, 0.7);
  --color-text-muted: rgba(255, 255, 255, 0.5);
  --color-border: rgba(255, 255, 255, 0.08);
  --font-display: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  --transition-smooth: cubic-bezier(0.4, 0, 0.2, 1);
  
  min-height: 100vh;
  background: var(--color-bg-primary);
  color: var(--color-text-primary);
  font-family: var(--font-display);
  overflow-x: hidden;
  position: relative;
}

.particles-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
}

.particle {
  position: absolute;
  background: var(--color-accent-gold);
  border-radius: 50%;
  opacity: 0.15;
  animation: particleFloat linear infinite;
}

@keyframes particleFloat {
  0% {
    transform: translateY(100vh) rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 0.15;
  }
  90% {
    opacity: 0.15;
  }
  100% {
    transform: translateY(-100vh) rotate(720deg);
    opacity: 0;
  }
}

.grid-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px);
  background-size: 80px 80px;
  pointer-events: none;
  z-index: 0;
}

.gradient-orb {
  position: fixed;
  border-radius: 50%;
  filter: blur(100px);
  pointer-events: none;
  z-index: 0;
}

.gradient-orb-1 {
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(201, 169, 98, 0.08) 0%, transparent 70%);
  top: -200px;
  right: -200px;
  animation: orbFloat 20s ease-in-out infinite;
}

.gradient-orb-2 {
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(201, 169, 98, 0.05) 0%, transparent 70%);
  bottom: -150px;
  left: -150px;
  animation: orbFloat 25s ease-in-out infinite reverse;
}

@keyframes orbFloat {
  0%, 100% { transform: translate(0, 0); }
  25% { transform: translate(30px, -30px); }
  50% { transform: translate(-20px, 20px); }
  75% { transform: translate(-30px, -20px); }
}

.nav-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 20px 0;
  transition: all 0.4s var(--transition-smooth);
}

.nav-header.nav-scrolled {
  background: rgba(10, 10, 10, 0.95);
  backdrop-filter: blur(20px);
  padding: 15px 0;
  border-bottom: 1px solid var(--color-border);
}

.nav-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav-logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-text {
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 4px;
  background: linear-gradient(135deg, var(--color-accent-gold) 0%, var(--color-accent-gold-light) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.nav-year {
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 3px;
  color: var(--color-text-muted);
  padding: 8px 16px;
  border: 1px solid var(--color-border);
  border-radius: 4px;
}


.hero-section {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  padding: 120px 40px 80px;
}

.hero-content {
  text-align: center;
  max-width: 900px;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 12px 28px;
  background: rgba(201, 169, 98, 0.1);
  border: 1px solid rgba(201, 169, 98, 0.3);
  border-radius: 100px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 4px;
  color: var(--color-accent-gold);
  margin-bottom: 40px;
}

.badge-icon {
  font-size: 10px;
  animation: twinkle 2s ease-in-out infinite;
}

@keyframes twinkle {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.5; transform: scale(0.8); }
}

.hero-title {
  margin: 0 0 30px;
  line-height: 1.1;
}

.title-year {
  display: block;
  font-size: clamp(80px, 15vw, 180px);
  font-weight: 800;
  letter-spacing: -5px;
  background: linear-gradient(180deg, var(--color-text-primary) 0%, rgba(255,255,255,0.3) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 0.9;
}

.title-text {
  display: block;
  font-size: clamp(20px, 3vw, 28px);
  font-weight: 400;
  color: var(--color-text-secondary);
  letter-spacing: 2px;
  text-transform: uppercase;
  margin: 20px 0 10px;
}

.title-highlight-wrapper {
  position: relative;
  display: inline-block;
}

.title-highlight {
  display: block;
  font-size: clamp(32px, 5vw, 56px);
  font-weight: 600;
  color: var(--color-accent-gold);
  letter-spacing: -1px;
}

.title-underline {
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 100%;
  height: 12px;
  color: var(--color-accent-gold);
  opacity: 0.4;
}

.hero-subtitle {
  font-size: clamp(16px, 2vw, 20px);
  color: var(--color-text-secondary);
  line-height: 1.7;
  max-width: 600px;
  margin: 0 auto 60px;
}

.scroll-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  color: var(--color-text-muted);
  font-size: 12px;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.mouse {
  width: 26px;
  height: 42px;
  border: 2px solid var(--color-text-muted);
  border-radius: 20px;
  position: relative;
}

.wheel {
  width: 4px;
  height: 8px;
  background: var(--color-accent-gold);
  border-radius: 2px;
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  animation: scroll 2s ease-in-out infinite;
}

@keyframes scroll {
  0%, 100% { opacity: 1; transform: translateX(-50%) translateY(0); }
  50% { opacity: 0.3; transform: translateX(-50%) translateY(12px); }
}

.section-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-tag {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 4px;
  color: var(--color-accent-gold);
  margin-bottom: 20px;
  padding: 10px 20px;
  background: rgba(201, 169, 98, 0.1);
  border-radius: 4px;
}

.section-title {
  font-size: clamp(28px, 4vw, 42px);
  font-weight: 600;
  margin: 0;
  letter-spacing: -1px;
}

.section-divider {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 25px;
}

.section-divider span {
  width: 8px;
  height: 8px;
  background: var(--color-accent-gold);
  border-radius: 50%;
  opacity: 0.6;
}

.section-divider span:nth-child(2) {
  width: 30px;
  border-radius: 4px;
  opacity: 1;
}

.video-section {
  padding: 100px 0 120px;
  position: relative;
  z-index: 1;
}

.video-wrapper {
  position: relative;
  max-width: 1000px;
  margin: 0 auto;
}

.video-frame {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  background: var(--color-bg-secondary);
}

.video-glow {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle at center, rgba(201, 169, 98, 0.1) 0%, transparent 50%);
  pointer-events: none;
  z-index: -1;
}

.video-border {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid var(--color-border);
  border-radius: 16px;
  pointer-events: none;
  z-index: 10;
}

.video-frame video {
  width: 100%;
  display: block;
  border-radius: 16px;
}

.video-reflection {
  position: absolute;
  bottom: -60%;
  left: 5%;
  right: 5%;
  height: 60%;
  background: linear-gradient(to bottom, rgba(10, 10, 10, 0.8), transparent);
  transform: scaleY(-1);
  opacity: 0.3;
  filter: blur(10px);
  pointer-events: none;
}

.stats-section {
  padding: 80px 0 120px;
  position: relative;
  z-index: 1;
  background: linear-gradient(180deg, transparent 0%, var(--color-bg-secondary) 50%, transparent 100%);
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.stat-item {
  text-align: center;
  padding: 40px 25px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  position: relative;
  transition: all 0.4s var(--transition-smooth);
}

.stat-item:hover {
  background: rgba(201, 169, 98, 0.05);
  border-color: rgba(201, 169, 98, 0.2);
  transform: translateY(-8px);
}

.stat-icon-wrapper {
  position: relative;
  margin-bottom: 20px;
}

.stat-icon-bg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: rgba(201, 169, 98, 0.1);
  border-radius: 50%;
}

.stat-icon {
  font-size: 36px;
  position: relative;
  z-index: 1;
}

.stat-number {
  font-size: 42px;
  font-weight: 700;
  color: var(--color-accent-gold);
  letter-spacing: -2px;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 8px;
  letter-spacing: 1px;
}

.stat-description {
  font-size: 13px;
  color: var(--color-text-muted);
  margin: 0;
}

.stat-line {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 3px;
  background: var(--color-accent-gold);
  transition: width 0.4s var(--transition-smooth);
  border-radius: 0 0 16px 16px;
}

.stat-item:hover .stat-line {
  width: 60%;
}

.timeline-section {
  padding: 100px 0;
  position: relative;
  z-index: 1;
}

.timeline {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
}

.timeline-line {
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(180deg, transparent, var(--color-border) 10%, var(--color-border) 90%, transparent);
  transform: translateX(-50%);
}

.timeline-item {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  position: relative;
}

.timeline-item:last-child {
  margin-bottom: 0;
}

.timeline-marker {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 60px;
  background: var(--color-bg-primary);
  border: 2px solid var(--color-accent-gold);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.timeline-marker span {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  color: var(--color-accent-gold);
}

.timeline-content {
  width: calc(50% - 60px);
  padding: 25px 30px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  transition: all 0.4s var(--transition-smooth);
}

.timeline-content:hover {
  background: rgba(201, 169, 98, 0.05);
  border-color: rgba(201, 169, 98, 0.2);
}

.timeline-item:not(.timeline-item-right) .timeline-content {
  margin-right: auto;
  text-align: right;
}

.timeline-item.timeline-item-right .timeline-content {
  margin-left: auto;
  text-align: left;
}

.timeline-content h4 {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 10px;
  color: var(--color-text-primary);
}

.timeline-content p {
  font-size: 14px;
  color: var(--color-text-secondary);
  margin: 0;
  line-height: 1.6;
}

.cta-section {
  padding: 120px 0;
  position: relative;
  z-index: 1;
}

.cta-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

.cta-pattern {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 800px;
  height: 800px;
  background: radial-gradient(circle at center, rgba(201, 169, 98, 0.08) 0%, transparent 60%);
  border-radius: 50%;
}

.cta-content {
  text-align: center;
  position: relative;
  padding: 80px 40px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid var(--color-border);
  border-radius: 24px;
  backdrop-filter: blur(20px);
}

.cta-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(201, 169, 98, 0.1);
  border-radius: 50%;
}

.cta-icon svg {
  width: 40px;
  height: 40px;
  color: var(--color-accent-gold);
}

.cta-title {
  font-size: clamp(28px, 4vw, 40px);
  font-weight: 600;
  margin: 0 0 20px;
  letter-spacing: -1px;
}

.cta-subtitle {
  font-size: 18px;
  color: var(--color-text-secondary);
  margin: 0 0 40px;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

.cta-signature {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  color: var(--color-accent-gold);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 2px;
}

.signature-line {
  width: 60px;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--color-accent-gold), transparent);
}

.page-footer {
  padding: 40px 0;
  border-top: 1px solid var(--color-border);
  position: relative;
  z-index: 1;
}

.footer-content {
  text-align: center;
  font-size: 13px;
  color: var(--color-text-muted);
  letter-spacing: 1px;
}


[data-aos] {
  opacity: 0;
  transition: all 0.8s var(--transition-smooth);
}

[data-aos="fade-up"] {
  transform: translateY(40px);
}

[data-aos="fade-down"] {
  transform: translateY(-40px);
}

[data-aos="zoom-in"] {
  transform: scale(0.95);
}

[data-aos].aos-animate {
  opacity: 1;
  transform: translateY(0) scale(1);
}

@media (max-width: 1024px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .nav-content {
    padding: 0 20px;
  }
  
  .hero-section {
    padding: 100px 20px 60px;
  }
  
  .section-container {
    padding: 0 20px;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .timeline-line {
    left: 30px;
  }
  
  .timeline-marker {
    left: 30px;
    width: 50px;
    height: 50px;
  }
  
  .timeline-content {
    width: calc(100% - 80px);
    margin-left: auto !important;
    text-align: left !important;
  }
  
  .timeline-item:not(.timeline-item-right) .timeline-content {
    text-align: left;
  }
  
  .cta-content {
    padding: 50px 25px;
  }
  
  .nav-year {
    display: none;
  }
}

@media (max-width: 480px) {
  .title-year {
    letter-spacing: -2px;
  }
  
  .hero-badge {
    padding: 10px 20px;
    font-size: 10px;
    letter-spacing: 2px;
  }
  
  .stat-number {
    font-size: 32px;
  }
}
</style>